import Form from "../../../Components/Form"
import { useState, useEffect } from "react"
import { updateProductInventory } from "../../../Model/Products"
import NumberInput from "../../../Components/Form/NumberInput"
import Text from "../../../Components/Text"
export const InventoryForm = ({ selectedProduct, afterAction }) => {
    const [productStock, setProductStock] = useState(0)

    useEffect(() => {
        if (selectedProduct) {
            setProductStock(selectedProduct.availableStock || 0)
        }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        await updateProductInventory(selectedProduct.id, productStock)
        afterAction()
    }
    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={"Inventar bearbeiten"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}> {"Inventar bearbeiten"}</Text>
            <NumberInput
                id={"productStock"}
                label="Verfügbarer Lagerbestand"
                action={(e) => setProductStock(e.target.value)}
                attribute={productStock}
                min={0} step="1"
                required={false}
            />
        </Form>
    )
}